import { t } from "i18next";
import { CountFrequency } from "@/services/api/entities/payment/types";

export const getPricePostfix = (countFrequency: CountFrequency) => {
  switch (countFrequency) {
    case CountFrequency.ONCE:
      return "";
    case CountFrequency.EVERY_MONTH:
      return `/${t("common.month").toLowerCase()}`;
    default:
      return "";
  }
};
